import { TSupportPortalFormField } from "../../lib/load-company-settings";
import Select, { TSelectOption } from "@atlas/uicorn/lib/Input/Select";
import Input from "@atlas/uicorn/lib/Input/Input";
import React from "react";
import { CustomField, CustomFieldTypes } from "../../lib/load-custom-fields";
import NumberInput from "@atlas/uicorn/lib/Input/NumberInput";
import SelectMulti from "@atlas/uicorn/lib/Input/SelectMulti";
import AddressInput from "@atlas/uicorn/lib/Input/AddressInput";
import DateInput from "@atlas/uicorn/lib/Input/DateInput";

const TicketFormField = function TicketFormField({
  field,
  customFields,
  ...rest
}: {
  field: TSupportPortalFormField & { options?: string[] };
  customFields: CustomField[];
  onChange?: (value: unknown) => void;
  disabled?: boolean;
}) {
  const customField = customFields.find((cf) => cf.key === field.key);

  if (!customField) {
    if (field.key === "email") {
      return <Input placeholder={field.label} type="email" {...rest} />;
    }

    return <Input placeholder={field.label} {...rest} />;
  }

  if (customField.type === CustomFieldTypes.TEXT) {
    const { onChange: onInputChange, ...inputProps } = rest;

    return (
      <Input
        placeholder={field.label}
        onChange={(event) => onInputChange && onInputChange(event.target.value)}
        {...inputProps}
      />
    );
  }

  if (
    customField.type === CustomFieldTypes.NUMBER ||
    customField.type === CustomFieldTypes.DECIMAL
  ) {
    return (
      <NumberInput
        precision={customField.type === CustomFieldTypes.DECIMAL ? 2 : 0}
        placeholder={field.label}
        {...rest}
      />
    );
  }

  if (customField.type === CustomFieldTypes.BOOLEAN) {
    return (
      <Select
        onChange={(key) =>
          rest.onChange?.(
            key === "True" ? true : key === "False" ? false : undefined
          )
        }
        options={booleanOptions}
        placeholder={field.label}
      />
    );
  }

  if (customField.type === CustomFieldTypes.DATE) {
    return <DateInput placeholder={field.label} {...rest} />;
  }

  if (customField.type === CustomFieldTypes.LIST) {
    const options = Array.isArray(field.options)
      ? field.options
      : customField.fieldMetadata;

    return (
      <Select
        placeholder={field.label}
        options={options.map((key) => ({
          key,
          label: key,
        }))}
        {...rest}
      />
    );
  }

  if (customField.type === CustomFieldTypes.MULTI_SELECT) {
    const options = Array.isArray(field.options)
      ? field.options
      : customField.fieldMetadata;

    return (
      <SelectMulti
        placeholder={field.label}
        options={options.map((key) => ({
          key,
          label: key,
        }))}
        {...rest}
      />
    );
  }

  if (customField.type === CustomFieldTypes.ADDRESS) {
    return <AddressInput {...rest} />;
  }

  return null;
};

export default TicketFormField;

const booleanOptions: TSelectOption[] = [
  { key: "False", label: "False" },
  { key: "True", label: "True" },
];
